import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallerPlan } from '@/models/callerPlan';

/** Loads `activeCallerSubscription` including `completedRidesCount` for the current billing period. */
export const fetchActiveCallerSubscription = async ({
  phoneNumber,
  callerId,
}: {
  phoneNumber?: string;
  callerId?: string;
}): Promise<CallerPlan | null> => {
  const response = await queryExecute({
    query: graphql(`
      query ActiveCallerSubscription($phoneNumber: String, $callerId: String) {
        activeCallerSubscription(phoneNumber: $phoneNumber, callerId: $callerId) {
          id
          callerId
          planName
          nextPlanName
          periodStartAt
          periodEndAt
          expectedPeriodEndAt
          isTrial
          transactionId
          timePlanSuspendPeriodStartDate
          timePlanSuspendPeriodEndDate
          timeZone
          completedRidesCount
        }
      }
    `),
    variables: {
      phoneNumber,
      callerId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.activeCallerSubscription ?? null;
};
